import { RadioButton } from '@/components/RadioButton';
import { LAYER_FORMAT_TYPE } from '@/constants/layer';
import { Layer } from '@/stores/viewer';
import { cn } from '@/utils/classname';
import { getLayerIcon } from '@/utils/nodeIcons';

export interface LayerNodeProps {
  layer: Layer;
  selected: boolean;
  onSelect: (layer: Layer) => void;
  onClose: () => void;
}

export const LayerNode = ({ layer, onSelect, selected, onClose }: LayerNodeProps) => {
  const handleSelect = async (layer: Layer) => {
    onSelect(layer);
    onClose();
  };

  const isCompatible = !(
    layer.formatType === LAYER_FORMAT_TYPE.OBJ ||
    layer.formatType === LAYER_FORMAT_TYPE.IFC ||
    layer.formatType === LAYER_FORMAT_TYPE.MESH_3D
  );

  return (
    <div className={cn('flex', 'justify-between', 'items-center', 'py-1')}>
      <div className={cn('flex', 'items-center', 'gap-2', 'text-neutral-600', 'justify-center')}>
        <RadioButton
          checked={selected}
          className={cn('flex', 'flex-row', 'items-center', 'cursor-default')}
          disabled={isCompatible}
          id="default"
          onChange={() => handleSelect(layer)}
          value={layer.id}
        />

        <div className={cn('flex', 'items-center', 'gap-2', 'text-neutral-600')}>
          <div
            className={cn(
              'w-5',
              'color-neutral-600',
              'text-3',
              'flex-none',
              getLayerIcon(layer.formatType),
            )}
          />
          <p className={cn('typo-text-small', 'text-neutral-800', 'whitespace-nowrap')}>
            {layer.name}
          </p>
        </div>
      </div>
    </div>
  );
};
